import { render, staticRenderFns } from "./login_forget_pwd.vue?vue&type=template&id=bd50102a&scoped=true"
import script from "./login_forget_pwd.vue?vue&type=script&lang=js"
export * from "./login_forget_pwd.vue?vue&type=script&lang=js"
import style0 from "./login_forget_pwd.vue?vue&type=style&index=0&id=bd50102a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd50102a",
  null
  
)

export default component.exports